var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWonikEventEntireEndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0522 1.70369C11.6757 1.40558 11.1264 1.471 10.8283 1.84811C10.5302 2.22585 10.595 2.77393 10.9727 3.07265C12.3553 4.16326 13.1478 5.79639 13.1478 7.5542C13.1478 10.6983 10.5894 13.2566 7.446 13.2566C4.30194 13.2566 1.74361 10.6983 1.74361 7.5542C1.74361 5.79701 2.53549 4.1645 3.9168 3.07451C4.29453 2.77639 4.35934 2.22831 4.06123 1.84997C3.76312 1.47223 3.21565 1.40805 2.83669 1.70554C1.03382 3.1282 0 5.26004 0 7.5542C0 11.6599 3.34033 14.9996 7.44538 14.9996C11.5504 14.9996 14.8908 11.6592 14.8908 7.5542C14.8908 5.2588 13.8557 3.12697 12.0522 1.70369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2832 1.1622V6.97321C6.2832 7.61449 6.80413 8.13542 7.44541 8.13542C8.08668 8.13542 8.60761 7.61449 8.60761 6.97321V1.1622C8.60761 0.520923 8.08668 0 7.44541 0C6.80413 0 6.2832 0.520923 6.2832 1.1622Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.72168C3.76339 4.52367 2.94531 5.91627 2.94531 7.49994C2.94531 9.98522 4.96003 11.9999 7.44531 11.9999C9.93059 11.9999 11.9453 9.98522 11.9453 7.49994C11.9453 5.96344 11.1752 4.6068 10 3.7949V7.66667C10 8.95533 8.88071 10 7.5 10C6.11929 10 5 8.95533 5 7.66667V3.72168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWonikEventEntireEndIcon);
export default __webpack_public_path__ + "static/media/wonik_event_entireEndIcon.e54981b10af0d0f0abf9f6a47afbc9f8.svg";
export { ForwardRef as ReactComponent };